import { makeStyles } from '@fluentui/react-components';

import { palette } from './palette';

export const useSurfaceStyles = makeStyles({
    card: {
        backgroundColor: palette.panelBg,
        borderRadius: palette.cardRadius,
        border: 'none',
        boxShadow: palette.softShadowMd,
    },
    cardInteractive: {
        backgroundColor: palette.panelBg,
        borderRadius: palette.cardRadius,
        border: 'none',
        boxShadow: palette.softShadowMd,
        cursor: 'pointer',
        transition: 'box-shadow 220ms ease, transform 220ms ease',
        '&:hover': {
            boxShadow: palette.softShadowLg,
            transform: 'translateY(-2px)',
        },
        '&:focus-visible': {
            outline: `2px solid ${palette.accent}`,
            outlineOffset: '2px',
        },
    },
    softAccent: {
        backgroundColor: palette.accentBg,
        borderRadius: palette.cardRadius,
    },
});
